import { render, staticRenderFns } from "./TituloLateral.vue?vue&type=template&id=635ffec0&scoped=true&"
import script from "./TituloLateral.vue?vue&type=script&lang=js&"
export * from "./TituloLateral.vue?vue&type=script&lang=js&"
import style0 from "./TituloLateral.vue?vue&type=style&index=0&id=635ffec0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635ffec0",
  null
  
)

export default component.exports